import { useNavigate } from "react-router-dom";

// icons
import ArrowIcon from "../icons/Arrow";

const HEIGHT = "h-[61px] sm:h-[73px] md:h-[69px] lg:h-[79px]";

const PageHeader = ({ title }) => {
  const navigate = useNavigate();

  return (
    <>
      <header
        className={`w-full flex justify-center fixed z-[100] top-0 left-0 border-b border-b-slate-200 backdrop-blur-sm bg-white/90 ${HEIGHT}`}
      >
        <div className="w-[90%] max-w-[1500px] flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            aria-label="Back"
            className="flex items-center justify-center text-[#664bc7] shrink-0 -ml-1"
          >
            <ArrowIcon styles="w-6 h-6 rotate-180" />
          </button>
          <h1 className="text-base sm:text-lg font-semibold text-[#3d5984] truncate">
            {title}
          </h1>
        </div>
      </header>
      {/* spacer so content clears the fixed header */}
      <div className={HEIGHT} />
    </>
  );
};

export default PageHeader;
